// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetFireDepartmentListRequestModel from '../../model/get-fire-department-list-request-model';
import GetFireDepartmentListRequestDTO from '../dto/get-fire-department-list-request-dto';
import dtoSchema from '../schemas/get-fire-department-list-request-schema';

export default abstract class GetFireDepartmentListRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetFireDepartmentListRequestDTO>) {
    super();
    if (data) {
      this.userId = data.userId;
    }
  }
  /**
  * @type {int64}
  */
  userId?: number;

  static toModel(dto: DeepPartial<GetFireDepartmentListRequestDTO>): GetFireDepartmentListRequestModel;
  static toModel(dto: DeepPartial<GetFireDepartmentListRequestDTO> | undefined | null): GetFireDepartmentListRequestModel | undefined;
  static toModel(dto: DeepPartial<GetFireDepartmentListRequestDTO> | undefined | null): GetFireDepartmentListRequestModel | undefined {
    return dto ? new GetFireDepartmentListRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetFireDepartmentListRequestModel> | GetFireDepartmentListRequestModel): GetFireDepartmentListRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      userId: unwrapped.userId,
    } as GetFireDepartmentListRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetFireDepartmentListRequestModel, can not map to GetFireDepartmentListRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
